import React from 'react';
import { Button } from '../ui/button';
import { PlayerProfile, PlayerData, PlayerInjury, PlayerTransfer, PlayerAchievement, PlayerStats } from '../../types/player';
import { usePlayerPdfExport } from '../../hooks/usePlayerPdfExport';

interface ExportReportButtonProps {
  playerProfile: PlayerProfile;
  playerData: PlayerData | null;
  playerInjuries: PlayerInjury[] | null;
  playerTransfers: PlayerTransfer[] | null;
  playerAchievements: PlayerAchievement[] | null;
  playerStats: PlayerStats[] | null;
  variant?: 'default' | 'outline' | 'secondary' | 'ghost' | 'link' | 'destructive';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  customLabel?: string;
}

export const ExportReportButton: React.FC<ExportReportButtonProps> = ({
  playerProfile,
  playerData,
  playerInjuries,
  playerTransfers,
  playerAchievements,
  playerStats,
  variant = 'outline',
  size = 'sm',
  customLabel
}) => {
  const { handleExportPDF } = usePlayerPdfExport();

  const handleClick = () => {
    console.log('Export Report button clicked');
    console.log('playerProfile:', playerProfile);
    console.log('playerData:', playerData);
    console.log('playerInjuries:', playerInjuries);
    console.log('playerTransfers:', playerTransfers);
    console.log('playerAchievements:', playerAchievements);
    console.log('playerStats:', playerStats);
    
    // First try a simple jsPDF test
    try {
      console.log('Testing basic jsPDF functionality...');
      import('jspdf').then(({ jsPDF }) => {
        try {
          const doc = new jsPDF();
          doc.text('Hello world!', 10, 10);
          doc.save('test.pdf');
          console.log('Basic jsPDF test succeeded');
          
          // Now try the actual export
          try {
            handleExportPDF(
              playerProfile.name,
              playerData,
              playerProfile,
              playerInjuries,
              playerTransfers,
              playerAchievements,
              playerStats
            );
            console.log('PDF export function completed');
          } catch (error) {
            console.error('Error in handleExportPDF:', error);
          }
        } catch (error) {
          console.error('Error in basic jsPDF test:', error);
        }
      }).catch(error => {
        console.error('Error importing jsPDF:', error);
      });
    } catch (error) {
      console.error('Error in jsPDF test wrapper:', error);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      className="whitespace-nowrap bg-transparent hover:bg-[#4E46FF] text-[#CECFD2] hover:text-white transition-colors"
      onClick={handleClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="7 10 12 15 17 10"></polyline>
        <line x1="12" y1="15" x2="12" y2="3"></line>
      </svg>
      {customLabel || 'Export Report'}
    </Button>
  );
};